import qs from 'query-string';

/**
 * This creates a breadcrumb trail for the question database that
 * prioritizes things in order of {company} > {role} > {type}
 */
const getBreadcrumbs = (
  tags = {},
  selectedCompany,
  selectedRole,
  selectedCategory,
) => {
  let companyTag;
  let roleTag;
  let categoryTag;

  const breadcrumbs = [{name: 'Home', url: '/'}, {name: 'Questions', url: '/questions'}];

  if (selectedCompany || selectedRole || selectedCategory) {
    const formatUrl = (query) => qs.stringifyUrl({url: '/questions', query});

    if (tags.company?.length && selectedCompany) {
      companyTag = tags.company.find((t) => t.id === selectedCompany);
      if (companyTag) {
        const params = {company: companyTag.id};
        breadcrumbs.push({name: companyTag.name, url: formatUrl(params)});
      }
    }

    if (tags.role?.length && selectedRole) {
      roleTag = tags.role.find((t) => t.id === selectedRole);
      if (roleTag) {
        const params = {company: companyTag?.id, role: roleTag?.id};
        breadcrumbs.push({name: roleTag.name, url: formatUrl(params)});
      }
    }

    if (tags.type?.length && selectedCategory) {
      categoryTag = tags.type.find((t) => t.id === selectedCategory);
      if (categoryTag) {
        const params = {company: companyTag?.id, role: roleTag?.id, type: categoryTag?.id};
        breadcrumbs.push({name: categoryTag.name, url: formatUrl(params)});
      }
    }
  }

  return breadcrumbs;
};

export default getBreadcrumbs;
